/**
 * Who loses their voice when all 32 are busy (07 §5): the lowest priority goes first; among
 * equals the farthest from the listener; among those the one that has been playing longest.
 * A newcomer that ranks below every playing sound is simply not played. Pure.
 */

export const MAX_VOICES = 32;

export interface VoiceSlot {
  busy: boolean;
  priority: number;
  /** Metres from the listener when it started. */
  distance: number;
  /** Audio-clock time it started. */
  startedAt: number;
}

/** A newcomer this much farther than an equal-priority victim is dropped instead of stealing. */
const DISTANCE_MARGIN = 1;

/** Index of the slot a new sound should take - free, or stolen - or -1 to drop the new sound. */
export function chooseSlot(slots: readonly VoiceSlot[], priority: number, distance: number): number {
  let victim = -1;
  for (let i = 0; i < slots.length; i++) {
    const s = slots[i];
    if (!s) continue;
    if (!s.busy) return i;
    const v = victim >= 0 ? slots[victim] : undefined;
    if (
      !v
      || s.priority < v.priority
      || (s.priority === v.priority && s.distance > v.distance)
      || (s.priority === v.priority && s.distance === v.distance && s.startedAt < v.startedAt)
    ) victim = i;
  }
  const v = victim >= 0 ? slots[victim] : undefined;
  if (!v) return -1;
  if (v.priority > priority) return -1;
  if (v.priority === priority && distance > v.distance + DISTANCE_MARGIN) return -1;
  return victim;
}
